import { IDR } from '@/libs/currency'

// eslint-disable-next-line import/prefer-default-export
export const spendingCategoryOptions = {
  chart: {
    type: 'donut',
  },
  responsive: [
    {
      breakpoint: 500,
      options: {
        chart: {
          width: '250px',
        },
        legend: {
          fontSize: '10px',
          markers: {
            width: 8,
            height: 8,
          },
        },
      },
    },
    {
      breakpoint: 800,
      options: {
        chart: {
          width: '350px',
        },
        legend: {
          fontSize: '12px',
          markers: {
            width: 8,
            height: 8,
          },
        },
      },
    },
    {
      breakpoint: 9999,
      options: {
        chart: {
          width: '320px',
        },
        legend: {
          fontSize: '12px',
          markers: {
            width: 8,
            height: 8,
          },
          offsetX: 10,
          offsetY: -15,
        },
      },
    },
  ],
  dataLabels: {
    enabled: false,
  },
  legend: {
    position: 'right',
  },
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
  tooltip: {
    custom: opts => {
      const name = opts.w.config.labels[opts.seriesIndex]
      return `<div class="p-[10px]">${name}</div>`
    },
  },
}
